import React from "react";
import {ConfirmationModal} from "../../../confirmationModal/ConfirmationModal";
import {deleteBot} from "../../../../modules/assistant/botListSlice";
import {useAppDispatch} from "../../../../../app/hooks";
import {useNavigate} from "react-router-dom";
import {showErrorToastNotification, showInfoToastNotification, showSuccessToastNotification} from "../../../toastNotification/toastNotificationSlice";

interface ConfirmationModalProps {
    publicId: string
    handleClose: (value?: any) => any
    onClickRedirectPath?: string
    entityName?: string
}

export const DeleteBotConfirmationModal: React.FC<ConfirmationModalProps> = ({
                                                                                 publicId,
                                                                                 handleClose,
                                                                                 onClickRedirectPath,
                                                                                 entityName
                                                                             }) => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const handleDelete = async () => {
        handleClose()
        if (onClickRedirectPath) {
            navigate(onClickRedirectPath)
        }
        dispatch(showInfoToastNotification({message: "Deleting assistant. We'll notify you once it's done."}))
        try {
            await dispatch(deleteBot(publicId)).unwrap()
            dispatch(showSuccessToastNotification({message: "Assistant deleted successfully"}))
        } catch {
            dispatch(showErrorToastNotification({message: "Failed to delete the assistant. Please try again."}))
        }
    }

    return <ConfirmationModal
        title={"Delete the assistant"}
        subtitle={"Are you sure you want to delete this assistant? This will permanently delete all associated conversations and data. You won't be able to undo this action."}
        closeButtonTitle={"No, cancel"}
        confirmButtonTitle={"Yes, delete"}
        onConfirm={handleDelete}
        onClose={handleClose}
        confirmationText={entityName}
    />
}
